// extracted by mini-css-extract-plugin
module.exports = {"lenserLogo":"LenserHeader_lenserLogo__2eHmC","subHeader":"LenserHeader_subHeader__1Zce4"};